import { useTranslation } from "react-i18next";

import { CaptainAvatar } from "./CaptainAvatar";
import { useCaptainEnabled } from "../hooks/useCaptainEnabled";
import { toggleCaptain } from "../hooks/useCaptainPanel";

import { Button } from "@/components/ui/v2/button";

export function CaptainTopbarButton() {
  const enabled = useCaptainEnabled();
  const { t } = useTranslation();

  if (!enabled) return null;

  return (
    <Button
      variant="outline"
      size="lg"
      onClick={toggleCaptain}
      className="gap-2 rounded-full bg-background-alt pl-1 hover:border-foreground hover:bg-background-alt"
    >
      <CaptainAvatar size="sm" />
      {t("captain.askCaptain", { defaultValue: "Ask Captain" })}
    </Button>
  );
}
